/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPmDashboardSummaryParams,
  PmDashboardSummary
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary Označi 'meku' stavku (ugovor nije počeo / ispod plana / nema realizacije) kao odrađenu
 */
export const dismissPmTask = (
    taskKey: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/api/v1/dashboard/pm-tasks/${taskKey}/dismiss`, method: 'POST', signal
    },
      );
    }
  


export const getDismissPmTaskMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissPmTask>>, TError,{taskKey: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof dismissPmTask>>, TError,{taskKey: string}, TContext> => {

const mutationKey = ['dismissPmTask'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dismissPmTask>>, {taskKey: string}> = (props) => {
          const {taskKey} = props ?? {};

          return  dismissPmTask(taskKey,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DismissPmTaskMutationResult = NonNullable<Awaited<ReturnType<typeof dismissPmTask>>>
    
    export type DismissPmTaskMutationError = unknown

    /**
 * @summary Označi 'meku' stavku (ugovor nije počeo / ispod plana / nema realizacije) kao odrađenu
 */
export const useDismissPmTask = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dismissPmTask>>, TError,{taskKey: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dismissPmTask>>,
        TError,
        {taskKey: string},
        TContext
      > => {

      const mutationOptions = getDismissPmTaskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary PM Task Inbox — otvorene stavke (grupirane po statusu) + nedavna aktivnost
 */
export const getPmDashboardSummary = (
    params?: GetPmDashboardSummaryParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PmDashboardSummary>(
      {url: `/api/v1/dashboard/pm-summary`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetPmDashboardSummaryQueryKey = (params?: GetPmDashboardSummaryParams,) => {
    return [
    `/api/v1/dashboard/pm-summary`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPmDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPmDashboardSummary>>, TError = unknown>(params?: GetPmDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPmDashboardSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPmDashboardSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPmDashboardSummary>>> = ({ signal }) => getPmDashboardSummary(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPmDashboardSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPmDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPmDashboardSummary>>>
export type GetPmDashboardSummaryQueryError = unknown


export function useGetPmDashboardSummary<TData = Awaited<ReturnType<typeof getPmDashboardSummary>>, TError = unknown>(
 params: undefined |  GetPmDashboardSummaryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPmDashboardSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPmDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getPmDashboardSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPmDashboardSummary<TData = Awaited<ReturnType<typeof getPmDashboardSummary>>, TError = unknown>(
 params?: GetPmDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPmDashboardSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPmDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getPmDashboardSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPmDashboardSummary<TData = Awaited<ReturnType<typeof getPmDashboardSummary>>, TError = unknown>(
 params?: GetPmDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPmDashboardSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary PM Task Inbox — otvorene stavke (grupirane po statusu) + nedavna aktivnost
 */

export function useGetPmDashboardSummary<TData = Awaited<ReturnType<typeof getPmDashboardSummary>>, TError = unknown>(
 params?: GetPmDashboardSummaryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPmDashboardSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPmDashboardSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




